export default {
  staleImageError: {
    title: 'Stale frame',
    description: 'The camera frame is outdated (stale)',
  },
};
